import React from 'react';

const FileIcon = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.2002 2H4.4002C4.08194 2 3.77671 2.12643 3.55167 2.35147C3.32662 2.57652 3.2002 2.88174 3.2002 3.2V12.8C3.2002 13.1183 3.32662 13.4235 3.55167 13.6485C3.77671 13.8736 4.08194 14 4.4002 14H11.6002C11.9185 14 12.2237 13.8736 12.4487 13.6485C12.6738 13.4235 12.8002 13.1183 12.8002 12.8V5.6L9.2002 2Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.2002 2V5.6H12.8002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.3996 8.59998H5.59961" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10.3996 11H5.59961" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.79961 6.20001H6.19961H5.59961" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default FileIcon;
